import LocalStorage from 'app/utils/localStorage';

const isEqual = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

const isNull = (obj) =>
  obj === null ||
  obj === undefined ||
  (typeof obj === 'string' && obj.trim() === '');

const isEmpty = (obj) => {
  if (isNull(obj)) {
    return true;
  }

  return Object.keys(obj).length === 0;
};

const isNumeric = (str, base = 10) => !Number.isNaN(parseInt(str, base));

const isError = (e) =>
  e &&
  e.stack &&
  e.message &&
  typeof e.stack === 'string' &&
  typeof e.message === 'string';

const isFunction = (obj) => typeof obj === 'function';

const checkWithinSections = (sections, selectedSections) => {
  return sections.some((_section) => {
    return selectedSections.includes(_section.code);
  });
};

const checkSurrogatePair = (str) =>
  str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g);

const checkShowVoucherTooltip = (key, vouchers) => {
  if (
    vouchers.length === 0 ||
    !Boolean(vouchers[0]) ||
    vouchers[0].isUsed ||
    vouchers[0].isExpired
  ) {
    return false;
  }
  const latestAvaliableVoucher = LocalStorage.getItem(key, null);
  if (parseInt(latestAvaliableVoucher, 10) !== vouchers[0].id) {
    LocalStorage.setItem(key, vouchers[0].id);
    return true;
  } else {
    return false;
  }
};

const getUseablePreviewVoucher = (vouchers, storyId) => {
  if (
    !vouchers ||
    !Array.isArray(vouchers.list) ||
    vouchers.list.length === 0
  ) {
    return false;
  }

  return vouchers.list.find(
    (voucher) =>
      voucher.effectExtra.storyId === storyId &&
      !voucher.isUsed &&
      !voucher.isExpired
  );
};

const checkEmail = (email) => {
  const EMAIL_REG =
    /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
  return EMAIL_REG.test(email);
};

const checkPassword = (password) => {
  const PASSWORD_REG =
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d~`!@#.,:;'"-_{}$%^&*()+|=]{8,}$/;
  return PASSWORD_REG.test(password);
};

export default {
  isEqual,
  isEmpty,
  isNull,
  isNumeric,
  isError,
  isFunction,
  checkWithinSections,
  checkSurrogatePair,
  checkShowVoucherTooltip,
  getUseablePreviewVoucher,
  checkEmail,
  checkPassword,
};



// WEBPACK FOOTER //
// ./src/app/utils/validators.js